import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Stepper from './Stepper';
import StepDetails from './StepDetails';
import { ILink } from 'tbk-components/src/components/Button';

interface IStepI18nProps {
	step?: string;
}

export interface IStep {
	stepTitle: string;
	instructions?: string;
	detailedInstructions?: string;
	status?: 'current' | 'completed' | null;
	skippable?: ILink;
}

export interface IAntennaSelectionStepsProgressProps extends IBaseElementProps {
	steps: IStep[];
	current?: number;
	i18n?: IStepI18nProps;
}

const AntennaSelectionStepsProgress: React.FC<
	IAntennaSelectionStepsProgressProps
> = ({ steps = [], current, className, classNames = [], i18n }) => (
	<div className={className || cn('steps-progress', ...classNames)}>
		<Stepper steps={steps} current={current} i18n={i18n} />
		<StepDetails steps={steps} current={current} i18n={i18n} />
	</div>
);

export default AntennaSelectionStepsProgress;
